import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from 'constants/apiConfig';
import { useGroupGuid } from 'components/IAP/hooks/commonHooks';

interface ValidateEmailNotInGroupParams {
  emailAddress: string;
}

export const useIsEmailInGroup = () => {
  const groupId = useGroupGuid();
  return useMutation({
    mutationFn: async (params: ValidateEmailNotInGroupParams) => {
      const response = await axios.post(apiConfig.apiGateway.isEmailInGroup, {
        ...params,
        groupId,
      });
      return response.data;
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.ERROR ||
          'Failed to validate email address. Please try again.'
      );
    },
  });
};
